import type { SXType } from "@dealer-center/core-components";

const itemAreaSX: SXType = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  width: "100%",
  justifyContent: "space-between"
};

const itemTitleSX: SXType = {
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  width: "20%"
};

const itemDetailsSX: SXType = {
  display: "flex",
  flexDirection: "row",
  gap: "12px",
  justifyContent: "flex-end",
  width: "1000px"
};
const itemDetailsItemSX: SXType = {
  gap: "2px",
  display: "flex",
  flexDirection: "column",
  width: "20%"
};

const itemDetailsLabelSX: SXType = {
  fontWeight: "bold",
  overflowWrap: "break-word"
};
const itemDetailsValueSX: SXType = {
  overflowWrap: "anywhere"
};

const CustomTreeItemGroupTransition: SXType = {
  marginLeft: "15px !important",
  paddingLeft: "4px !important",
  borderLeft: `1px dashed rgba(0, 0, 0, 0.5)`
};

export const treeItemStyles: Record<string, SXType> = {
  itemTitleSX,
  itemDetailsSX,
  itemAreaSX,
  CustomTreeItemGroupTransition,
  itemDetailsLabelSX,
  itemDetailsValueSX,
  itemDetailsItemSX
};
